// Notifikace na tomto zařízení (Web Push). Na iPhonu fungují jen v appce přidané na plochu (iOS 16.4+).
import { api } from './api';
import { isIos, isStandalone } from './pwa';

export type PushState = 'unsupported' | 'ios-install' | 'denied' | 'off' | 'on';

const supported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

async function registration(): Promise<ServiceWorkerRegistration> {
  // Ve vývoji (bez produkční registrace) se service worker zaregistruje až tady.
  return (await navigator.serviceWorker.getRegistration()) ?? (await navigator.serviceWorker.register('/sw.js'));
}

export async function pushState(): Promise<PushState> {
  if (isIos() && !isStandalone()) return 'ios-install';
  if (!supported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  return sub && Notification.permission === 'granted' ? 'on' : 'off';
}

const b64ToBytes = (b64: string) => {
  const s = atob((b64 + '='.repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(s, (c) => c.charCodeAt(0));
};

export async function enablePush(publicKey: string): Promise<void> {
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error(perm === 'denied' ? 'Oznámení jsou v prohlížeči zakázaná. Povolte je v nastavení prohlížeče.' : 'Oznámení nebyla povolena.');
  const reg = await registration();
  await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) ?? (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(publicKey) }));
  const j = sub.toJSON();
  await api('POST', '/push/subscribe', { endpoint: j.endpoint, keys: j.keys });
}

export async function disablePush(): Promise<void> {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (!sub) return;
  await api('DELETE', '/push/subscribe', { endpoint: sub.endpoint });
  await sub.unsubscribe();
}
